/* eslint-disable no-restricted-imports */
import styled from 'styled-components';

export const Banner = styled.div`
  background-color: #0050dc;
  border-radius: 10px;
  color: ${({ theme }) => theme.olist.color.neutral.softest};
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
`;

export const LogoTiny = styled.img`
  height: 40px;
  width: 65px;
`;
